/* TS Range Switcher — tab behaviour for sections/ts-range-switcher.liquid.
   Initialises every instance on the page, and any section re-rendered by
   the theme editor. */
const SELECTOR = '[data-ts-rs]';

function init(root) {
  var tabs = root.querySelectorAll('[data-rs-tab]'),
    panels = root.querySelectorAll('[data-rs-panel]');
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      var i = t.getAttribute('data-rs-tab');
      tabs.forEach(function (x) {
        x.classList.remove('is-on');
        x.setAttribute('aria-selected', 'false');
      });
      panels.forEach(function (p) {
        p.classList.remove('is-on');
      });
      t.classList.add('is-on');
      t.setAttribute('aria-selected', 'true');
      root.querySelector('[data-rs-panel="' + i + '"]').classList.add('is-on');
    });
  });
}

function initAll(scope) {
  (scope || document).querySelectorAll(SELECTOR).forEach(function (r) {
    if (r.dataset.rsReady) return;
    r.dataset.rsReady = '1';
    init(r);
  });
}

initAll();
document.addEventListener('shopify:section:load', function (e) {
  initAll(e.target);
});
